import React from 'react';
import { CTAButton } from './CTAButton';
export function Hero() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-8 px-4 bg-white" data-id="element-67">
      <div className="max-w-2xl mx-auto text-center" data-id="element-68">
        <h1 className="text-lg sm:text-2xl font-heading font-bold text-brand-forest leading-snug mb-3" data-id="element-69">
          ¿Y si el secreto para despertar con energía y ver tu rostro
          deshinchado no estuviera en una pastilla más, sino en lo que pones en
          tu plato?
        </h1>

        <p className="text-xs sm:text-sm text-brand-text leading-relaxed mb-6" data-id="element-70">
          Descubre{' '}
          <strong className="text-brand-forest" data-id="element-71">Tiroides en Rescate</strong>: la
          guía definitiva para "apagar" la inflamación, recuperar tu metabolismo
          y sanar desde la raíz. El conocimiento práctico que tu cuerpo necesita
          para dejar de luchar contra su propia glándula, organizado en un
          sistema de 15 minutos para recuperar tu vida.
        </p>

        <div className="mb-6" data-id="element-72">
          <button onClick={scrollToPricing} className="block w-full cursor-pointer" data-id="element-73">
            <img src="https://cdn.magicpatterns.com/uploads/gPWTj6wtg4A7r7nqnsr2xj/Diseno-sin-titulo-_1_.webp" alt="Tiroides en Rescate - Protocolo Maestro" className="w-full h-auto object-contain" loading="eager" data-id="element-74" />
          </button>
        </div>

        <CTAButton className="mb-4" variant="primary" data-id="element-75">
          SÍ, QUIERO RECUPERAR MI ENERGÍA 🌿
        </CTAButton>

        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-xs text-brand-muted" data-id="element-76">
          <span data-id="element-77">🔒 Pago 100% Seguro</span>
          <span data-id="element-78">•</span>
          <span data-id="element-79">📥 Entrega Inmediata</span>
          <span data-id="element-80">•</span>
          <span data-id="element-81">🌍 Paga en tu Moneda Local</span>
          <span data-id="element-82">•</span>
          <span data-id="element-83">🛡️ Garantía Total</span>
        </div>
      </div>
    </section>;
}